module.exports = __webpack_public_path__ + "img/tight-bot-qq.e8a9096c.png";